import { Typography, Container, Button, Box, Grid } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';
import Dashboard from './Components/Dashboard';
import { FeatureItem } from './Components/FeatureItem';

const features = [
	{
		icon: <CloudUploadIcon fontSize="large" />,
		title: "CSV Upload",
		text: "Easily upload CSV files to add items to Walmart inventory."
	},
	{
		icon: <InventoryIcon fontSize="large" />,
		title: "Batch Processing",
		text: "Add multiple items at once with minimal manual input."
	},
	{
		icon: <LocalShippingIcon fontSize="large" />,
		title: "WFS Shipments",
		text: "Create and manage shipments to Walmart Fulfillment Services."
	},
	{
		icon: <IntegrationInstructionsIcon fontSize="large" />,
		title: "Marter Integration",
		text: "Seamlessly connect with your Marter Buy List for better workflow."
	},
];

const HomePage = () => {
	const { theme } = useTheme();
	const { isAuth, user, userSU } = useAuth();
	const navigate = useNavigate();

	const styles = {
		button: {
			textTransform: 'none',
			fontFamily: theme.fontFamily,
			color: theme.text.negative,
			borderRadius: '20px',
			backgroundColor: theme.color.primary,
			border: `1px solid ${theme.border.light}`,
			mt: 3,
			mb: 2,
			px: "100px",
			fontSize: "150%"
		},
		modal: {
			bgcolor: theme.background.primary,
			border: `4px solid ${theme.color.primary}`,
			p: 3,
			textAlign: 'center',
			maxWidth: 400,
			borderRadius: 2,
			boxShadow: 3,
			mx: 'auto',
			mt: 10
		},
		text: {
			fontFamily: theme.fontFamily,
			color: theme.text.primary
		},
		buttonModal: {
			textTransform: 'none',
			fontFamily: theme.fontFamily,
			color: theme.text.negative,
			borderRadius: '20px',
			border: `1px solid ${theme.border.light}`
		}
	}

	if (!!userSU && !user) {
		// Redirect to super-user dashboard if isSuperUser
		return <Navigate to="/super-user" replace />;
	}

	return <>
		{(!isAuth || !user) ? (
			<>
				<Box sx={{ height: '80vh', backgroundColor: theme.background.primary, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
					<Container>
						<Typography variant="h2" sx={{ color: theme.color.primary, fontFamily: theme.fontFamily, }}>
							Streamline Your Walmart Inventory Management
						</Typography>
						<Typography variant="h5" sx={{ color: theme.text.secondary, fontFamily: theme.fontFamily, }}>
							Upload, manage, and ship inventory with ease.
						</Typography>
						<Button variant="contained" sx={styles.button} onClick={() => navigate('/login')} >
							Get Started
						</Button>
					</Container>
				</Box>

				<Box sx={{ minHeight: '60vh', padding: '2rem', backgroundColor: theme.background.homeSection, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
					<Grid container spacing={4} sx={{ maxWidth: '70vw' }}>
						{features.map((feature, index) => (
							<Grid item xs={12} sm={6} md={3} key={index}>
								<FeatureItem {...feature} />
							</Grid>
						))}
					</Grid>

					<br />
					<br />

					<iframe
						src="https://www.youtube-nocookie.com/embed/suzP_VmDM2M?si=ywLrHyLlenHVGgme"
						title="YouTube video player"
						frameborder="0"
						allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						allowfullscreen
						style={{ width: '40vw', height: '25vw', }}
					></iframe>
				</Box>

				<footer style={{ backgroundColor: theme.background.primary, padding: 20, textAlign: 'center', color: theme.text.primary, }}>
					<Typography variant="body2" sx={{ fontFamily: theme.fontFamily, }}>Contact us: team@inventoryfalcon.com</Typography>
					<Typography variant="subtitle1" sx={{ fontFamily: theme.fontFamily, }}>© {new Date().getFullYear()} Inventory Falcon</Typography>
				</footer>
			</>
		) : (
			<Dashboard />
		)}
	</>
};

export default HomePage;
